import Script from 'react-load-script';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { reaction } from 'mobx';

@inject('userLocationStore')
@observer
export default class TrustArc extends Component {
    state = {
        defaultScriptUrl: 'https://consent.trustarc.com/notice?domain=goto.com&c=teconsent&js=nj&noticeType=bb&text=true&privacypolicylink=https://www.goto.com/company/legal/privacy&gtm=1&oc=1',
        euCountriesScriptUrl: 'https://consent.trustarc.com/notice?domain=goto.com&c=teconsent&js=nj&noticeType=bb&text=true&privacypolicylink=https://www.goto.com/company/legal/privacy&gtm=1',
        useScript: false
    };

    geoLocationData = reaction(
        () => this.props.userLocationStore.userLocation,
        () => {
            this.setState({
                useScript: true
            });
        }
    );

    handleScriptLoad() {
        const bar = document.createElement('div');
        bar.setAttribute('id', 'consent_blackbar');
        bar.style.cssText = 'position: fixed; bottom: 0; width: 100%; z-index: 10000000000;';
        document.body.appendChild(bar);
        // set the link target to open in a new tab
        const mutationObserver = new MutationObserver(((mutations) => {
            mutations.forEach(() => {
                const trusteDiv = document.getElementById('truste-cookie-button');

                if (trusteDiv) {
                    const trusteLink = document.getElementById('truste-cookie-button');
                    if (trusteLink) {
                        trusteLink.setAttribute('target', '_blank');
                    }
                }
            });
        }));

        mutationObserver.observe(document.querySelector('#consent_blackbar'), { attributes: false, childList: true, subtree: true });
        window.ghTrustArcLoaded = true;
    }

    render() {
        const { userLocationStore } = this.props;
        if (window.ghTrustArcLoaded) return false;
        if (!this.state.useScript) return null;
        return (
            <Script
                async
                onLoad={this.handleScriptLoad}
                url={userLocationStore.isUserInEu || !userLocationStore.userLocation ? this.state.euCountriesScriptUrl : this.state.defaultScriptUrl}
            />
        );
    }
}
